import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { PepsicoLogoBlue, PepsicoWhite } from '../../../assets/images';
import { useStyles } from './styles';

interface Props {
  outside?: boolean;
}

const AuthHeader = ({ outside = false }: Props) => {
  const classes = useStyles();
  return (
    <>
      {!outside ? (
        <Grid item style={{ zIndex: 2 }}>
          <Box pt={5} pb={3} px={4}>
            <img
              src={PepsicoLogoBlue}
              width="168"
              alt="Logo"
              draggable="false"
            />
          </Box>
        </Grid>
      ) : (
        <Grid container justify="center" style={{ zIndex: 2 }}>
          <Box mb={3}>
            <img src={PepsicoWhite} width="168" alt="Logo" draggable="false" />
          </Box>
        </Grid>
      )}

      <img
        className={classes.footerLogo}
        src="https://pepsico-bucket.s3.us-east-1.amazonaws.com/uploads/2023/10/13/39440e4e-b2d8-4329-bc36-6183ab448af8.png"
        alt="pepsico_car_logo"
      ></img>
    </>
  );
};

export default AuthHeader;
